import React from 'react'
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer">

    <p>@2024 FirstWebsite. All rights reserved</p>        
    <ul>
        <li>Terms of services</li>
        <li>Privacy policy</li>

    </ul>
    </div>
  )
}
